import { MERIDIAN_ORG_ID } from '../../hooks/use-role';
import { TYPE_NAME_TO_KEY } from './constants';

export const getDeviceTypeKey = (row) => row?.type_key || TYPE_NAME_TO_KEY[row?.type_name] || null;

export const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

/** Бэкенд отдаёт напряжение в милливольтах */
export const formatVoltage = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const millivolts = Number(value);
  if (Number.isNaN(millivolts)) return formatValue(value);
  return (millivolts / 1000).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString('ru-RU');
};

const formatForTypes = (formatter, allowedTypes) => (value, row) => {
  if (!allowedTypes.includes(getDeviceTypeKey(row))) return '-';
  return formatter(value, row);
};

export const formatControllerOnly = (formatter) => formatForTypes(formatter, ['controller']);
export const formatCounterOnly = (formatter) => formatForTypes(formatter, ['counter']);
export const formatAttachedOnly = (formatter) => formatForTypes(formatter, ['counter', 'sensor']);

export const isForeignOrganization = (organizationId) => {
  if (organizationId == null || organizationId === '') return false;
  return Number(organizationId) !== MERIDIAN_ORG_ID;
};

export const getCompanyName = (organizationId, organizationsById) => {
  if (!isForeignOrganization(organizationId)) return null;
  return organizationsById[organizationId] || organizationsById[String(organizationId)] || `#${organizationId}`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const number = Number(value);
  if (Number.isNaN(number)) return formatValue(value);
  return number.toLocaleString('ru-RU');
};

export const getDictName = (name, key, dict) => name || dict?.[key] || key || null;

export const getStateLabel = (state, typeKey, statesByType) =>
  state?.description || statesByType?.[typeKey]?.[state?.key] || state?.key || null;
